import { inject } from '@angular/core';
import { PlexEnvironment } from '@app/env';
import { IStandardConfigDto } from "@app/shared/models/dtos/standard-config";
import { Validator } from 'fluentvalidation-ts';
import moment from 'moment';

export class StandardConfigDtoValidator extends Validator<IStandardConfigDto> {

  public environment = inject(PlexEnvironment);

  constructor() {
    super();

    let minNewEffectiveDate = moment("2000-01-01").toDate();
    let maxNewEffectiveDate = moment("2099-01-01").toDate();

    this.ruleFor('Name')
      .notEmpty()
      .withMessage('Description is required');

    this.ruleFor('EffectiveDate')
      .must((model, field) => {
        if (model === null) { return true; }
        if (field.StandardConfigurationId <= 0) {
          return model > minNewEffectiveDate && model < maxNewEffectiveDate
        } return true;
      }).withMessage(`Effective Date must be specified and between ${minNewEffectiveDate.toDateString()} and ${maxNewEffectiveDate.toDateString()}`);

    this.ruleFor('IsDefault')
      .must((isDefault, IStandardConfigDtoModel) => !(isDefault && !IStandardConfigDtoModel.IsActive))
      .withMessage(`Standard Config must be Active in order to be a Default`);

    if (this.environment.showDelawareBasin) {
      this.ruleFor('IsDELDefault')
        .must((isDELDefault, IStandardConfigDtoModel) => !(isDELDefault && !IStandardConfigDtoModel.IsActive))
        .withMessage(`Standard Config must be Active in order to be a DEL Default`);
    }
  }
}